import type { ILogger } from '@trimble/logging';
import { asError } from '@trimble/logging';
import { batch } from 'solid-js';
import { waitForReactive } from '@trimble/solidjs-utils';
import type { FeatureExtractionContextType } from '@mobile-mapping/providers';
import type { SavedCadEditingState } from './multipane-view.types';
import { VIEW_LOAD_TIMEOUT_MS } from './apply-multipane-view-data';

export async function applyCadEditingState(
  context: FeatureExtractionContextType,
  cadEditing: SavedCadEditingState,
  logger: ILogger,
  isCurrent: () => boolean
): Promise<void> {
  let status: string;
  try {
    status = await waitForReactive(
      context.layersLoadStatus,
      (s) => s !== 'pending',
      VIEW_LOAD_TIMEOUT_MS
    );
  } catch (e) {
    logger.debug('CAD editing state restore timed out', undefined, asError(e));
    return;
  }
  if (status !== 'success') return;
  if (!isCurrent()) {
    logger.debug('Skipped stale CAD editing state restore');
    return;
  }
  batch(() => {
    if (cadEditing.selectedLayerId !== undefined) {
      context.setSelectedLayerId(cadEditing.selectedLayerId);
    }
    if (cadEditing.desiredDrawingTool !== undefined) {
      context.setDesiredDrawingTool(cadEditing.desiredDrawingTool);
    }
    if (cadEditing.visibleLayerIds !== undefined) {
      context.setVisibleLayerIds(cadEditing.visibleLayerIds);
    }
  });
}
